import { $ } from './../helpers/query'

export default () => {
  $('.hero').each(heroSection => {

    const video = document.querySelector('#hero-video');
    const videoEl = video.querySelector('video');

    if (videoEl) {
      heroSection.querySelector('.hero__title').style.display = 'none';
      video.classList.add('hero-video--no-img')
    }

  })
}
